var _module = require('../module');

require('angular-ui-router');
require('angular-base64');
require('../../services/add-phone-modal');
require('../../services/lr-touch');
require('../../services/login-or-register-modal');
require('../../services/user');
require('../../filters');

_module.requires.push('ui.router', 'base64');

_module.component('inviteRejectAccept', {
    controllerAs: 'ira',
    controller: [
        '$log',
        '$state',
        '$stateParams',
        '$addPhoneModal',
        '$errorModal',
        '$loginOrRegisterModal',
        '$base64',
        '$user',
        '$q',

        function inviteRejectAcceptCtrl($log, $state, $stateParams, $addPhoneModal, $errorModal, $loginOrRegisterModal, $base64, $user, $q) {
            $log.debug('inviteRejectAccept', $stateParams.type);

            var ira = this;

            if($user.account_type !== 'guest') {
                return $state.go('search');
            }

            ira.type = $stateParams.type;

            if(ira.type === 'accepted' && $stateParams.d) {
                var details = JSON.parse($base64.decode($stateParams.d));
                ira.phone = details.phone;
                ira.email = details.email;
                ira.userId = details.userId;
            }

            // Functions
            ira.signin = function signin(type) {
                var data = {
                    hideRegistration: true,
                    autosubmitLogin: true
                };
                data[type] = this[type];
                if(!ira[type]) {
                    $addPhoneModal(ira.userId)
                        .then(function (response) {
                            $log.debug('Phone Added! ', response);
                            data[type] = response.phone;
                            $loginOrRegisterModal(data);
                        })
                        .catch(function (err) {
                            parent.phone = false;
                            $log.error('Something went wrong while trying to save the phone and send verification.', err);
                            return false;
                        });
                } else {
                    $loginOrRegisterModal(data);
                }
            };
        }
    ],
    template: require('./index.html')
});
